import { clearedFilters } from '../../shared/pleatingOverview';

export default {
    namespaced: true,
    state: {
        filters: { ...clearedFilters },
    },
    mutations: {
        setFilters(state, filters) {
            state.filters = { ...filters };
        },
    },
    getters: {
        getFilters(state) {
            return state.filters;
        },
    },
};
